import get from 'lodash.get';

const getPublishingType = (rootState) => get(rootState, 'user.userData.publishing_type', null);

export default getPublishingType;
